import { clientId } from './index';

const accessToken = window.localStorage.getItem('access_token');
const expiresIn = window.localStorage.getItem('expiresIn');
const OAUTH_ROOT = 'https://connect.internetofefficiency.com';

const clearTokens = () => {
  window.localStorage.removeItem('access_token');
  window.localStorage.removeItem('expiresIn');
};

const getTokenFromQueryParams = params => new URLSearchParams(params);

export const requestToken = () => {
  clearTokens();
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('client_id', clientId);
  searchParams.set(
    'redirect_uri',
    `${window.location.protocol}//${window.location.host}/oauth/redirect`
  );
  searchParams.set('response_type', 'token');
  window.localStorage.setItem('redirect', window.location.pathname);
  window.location = `${OAUTH_ROOT}/oauth/authorize?${searchParams.toString()}`;
};

export default () => {
  if (window.location.pathname.startsWith('/external/')) {
    const queryParams = getTokenFromQueryParams(window.location.search);
    const token = queryParams.get('access_token');
    if (token) {
      window.localStorage.setItem('access_token', token);
      console.log('found token', token);
      return { accessToken: token };
    }
    // todo: get token from iframe params
    return {};
  }

  if (window.location.pathname === '/oauth/redirect') {
    const redirectQueryParams = getTokenFromQueryParams(
      window.location.hash.substring(1)
    ); // implicit token
    const token = redirectQueryParams.get('access_token');

    if (token) {
      window.localStorage.setItem('access_token', token);
      window.localStorage.setItem(
        'expiresIn',
        redirectQueryParams.get('expires_in')
      );

      const redirect = window.localStorage.getItem('redirect')
        ? window.localStorage.getItem('redirect')
        : '/';

      window.localStorage.removeItem('redirect');
      return { accessToken: token, redirect };
    }
  }

  if (
    accessToken === null ||
    (expiresIn && Date.now() < parseInt(expiresIn, 10) * 1000)
  ) {
    requestToken();
    return {};
  }

  return {
    accessToken
  };
};



// WEBPACK FOOTER //
// ./src/auth.js